import { render, staticRenderFns } from "./CollectionRecordDetails.vue?vue&type=template&id=0c0fbcbc"
import script from "./CollectionRecordDetails.vue?vue&type=script&lang=js"
export * from "./CollectionRecordDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports